/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeTriangleAUpIcon16Regular = forwardRef('ArrowShapeTriangleAUpIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.158 12a1.25 1.25 0 0 1-1.056-1.919l3.842-6.065a1.25 1.25 0 0 1 2.112 0l3.841 6.065a1.25 1.25 0 0 1-1.056 1.92H4.158Zm.455-1.5h6.774L8 5.152 4.613 10.5Z" })));
});
